import I from 'immutable';

export default I.fromJS({
  firstname: 'Adrian',
});
